// scroll-reveal — gentle fade-up on scroll into view
// If reduced-motion: reveal everything immediately.
// Otherwise: reveal items already in/near viewport on load, then watch the rest.

const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
const targets = document.querySelectorAll('[data-reveal]');

if (reduce) {
  targets.forEach((el) => el.classList.add('is-revealed'));
} else {
  // Reveal anything already in viewport (or close to it) on first paint
  const initialReveal = (el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 1.1) el.classList.add('is-revealed');
  };
  targets.forEach(initialReveal);

  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
  );

  targets.forEach((el) => {
    if (!el.classList.contains('is-revealed')) io.observe(el);
  });

  // Safety net: if scrollY is at the bottom on load (back-button cases), reveal everything within 1s
  setTimeout(() => {
    targets.forEach((el) => {
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.5) el.classList.add('is-revealed');
    });
  }, 600);
}
